export type Cancel = () => void;

export type CancelGroup = Cancel & {
  add: (cancel: Cancel) => void;
};

/** Group cancel functions so they can be canceled together */
export const createCancelGroup = (...cancels: Cancel[]): CancelGroup => {
  const cancelSet = new Set<Cancel>(cancels);

  const add = (cancel: Cancel) => cancelSet.add(cancel);

  const cancel = () => {
    for (const cancel of cancelSet) {
      cancel();
    }
    cancelSet.clear();
  };

  cancel.add = add;

  return cancel;
};
